module.exports = __webpack_public_path__ + "media/images/404-8edd43df8b3c6cb20b39ce4c1c1d41a2.jpg";